import WalletAccounts from './WalletAccounts';

export default WalletAccounts;
